import { Decorator, FormApi } from "final-form"
import { RefObject } from "preact"

export function FocusFirstError<FormValues>(ref: RefObject<HTMLElement>): Decorator<FormValues> {
  return function decorator(form: FormApi<FormValues>) {
    const unsubscribe = form.subscribe(
      (state) => {
        const formEl = ref.current
        if (!formEl || !state.hasSubmitErrors || !state.submitErrors) return

        const firstErrorField = Object.keys(state.submitErrors)[0]
        const field = Array.from(formEl.querySelectorAll("input")).find(
          (input) => input.name === firstErrorField,
        )
        field?.focus()
      },
      {
        hasSubmitErrors: true,
        submitErrors: true,
      },
    )

    return unsubscribe
  }
}
